import actions from './actions';
import types from './mutation-types';
import { isNil } from 'lodash';

const state = {
	fetch: {
		isFetching: false,
		error: null
	},
	update: {
		isUpdating: false,
		error: null
	},
	delete: {
		isDeleting: false,
		error: null
	},
	bid: {}
};

const getters = {
	bid: state => state.bid,
	isFetching: state => state.fetch.isFetching,
	isUpdating: state => state.update.isUpdating,
	isDeleting: state => state.delete.isDeleting,
	deleteError: state => state.delete.error,
	formError: state => {
		if (state.fetch.error) return state.fetch.error;
		if (state.update.error) return state.update.error;
		return null;
	}
};

const mutations = {
	[types.FETCH_BID_START](state) {
		state.fetch.isFetching = true;
		state.fetch.error = null;
	},
	[types.FETCH_BID_SUCCESS](state, payload) {
		state.fetch.isFetching = false;
		state.bid = payload;
	},
	[types.FETCH_BID_ERROR](state, payload) {
		state.fetch.isFetching = false;
		state.fetch.error = payload;
	},
	[types.UPDATE_BID_START](state) {
		state.update.isUpdating = true;
		state.update.error = null;
	},
	[types.UPDATE_BID_SUCCESS](state, payload) {
		state.update.isUpdating = false;
		state.bid = payload;
	},
	[types.UPDATE_BID_ERROR](state, payload) {
		state.update.isUpdating = false;
		state.update.error = payload;
	},
	[types.DELETE_BID_START](state) {
		state.delete.isDeleting = true;
		state.delete.error = null;
	},
	[types.DELETE_BID_SUCCESS](state) {
		state.delete.isDeleting = false;
		state.bid = {};
	},
	[types.DELETE_BID_ERROR](state, payload) {
		state.delete.isDeleting = false;
		state.delete.error = payload;
	},
	[types.RESET_ALL](state) {
		state.bid = {};
		state.delete.error = null;
		state.update.error = null;
		state.fetch.error = null;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/bid-form/index.js